import { StyleSheet } from '@react-pdf/renderer';

export const generalStyles = StyleSheet.create({
  body: {
    paddingTop: 10,
    paddingBottom: 35,
    paddingHorizontal: 20
  },
  pageNumber: {
    fontSize: 9,
    left: 0,
    right: 20,
    textAlign: 'right',
    color: 'grey'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 0.5,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 6,
    fontSize: 9
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableColHeader: {
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderBottomColor: '#000',
    borderWidth: 0.5,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    borderWidth: 0.5,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableGroupCol: {
    borderStyle: 'solid',
    borderColor: '#403f3f',
    borderWidth: 0.5,
    borderLeftWidth: 0,
    borderTopWidth: 0.5,
    borderBottomWidth: 0.5
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 10,
    fontWeight: 500
  },
  tableCell: {
    margin: 5,
    fontSize: 8
  },
  tableGCell: {
    margin: 5,
    fontSize: 8,
    fontWeight: 600
  }
});

export const noBorderTableStyle = StyleSheet.create({
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderColor: '#bfbfbf',
    marginTop: 10,
    fontSize: 9,
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: 'auto',
    flexDirection: 'row'
  },
  tableCol: {
    borderStyle: 'solid',
    borderColor: '#bfbfbf'
  },
  tableCellHeader: {
    margin: 4,
    fontSize: 10,
    fontWeight: 500
  },
  tableCell: {
    margin: 4,
    fontSize: 9
  }
});
